import { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface CouponInputProps {
  onApply: (code: string) => void;
  isLoading?: boolean;
  error?: string;
}

export function CouponInput({ onApply, isLoading, error }: CouponInputProps) {
  const [code, setCode] = useState('');

  const handleApply = () => {
    if (code.trim()) {
      onApply(code.trim().toUpperCase());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && code.trim()) {
      handleApply();
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Enter coupon code"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          error={!!error}
          sx={{
            '& .MuiInputBase-input': {
              textTransform: 'uppercase',
            },
          }}
        />
        <Button
          variant="contained"
          onClick={handleApply}
          disabled={!code.trim() || isLoading}
          sx={{ minWidth: 80, height: 40 }}
        >
          {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Apply'}
        </Button>
      </Box>
      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}
